// AuthGuard.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AuthGuard: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
const location = useLocation();
  if (!isAuthenticated) {
    // localStorage.setItem('routeUrl', location.pathname + location.search);
    return <Navigate to="/login" />;
  }

  return children;
};

export default AuthGuard;
